
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigationUtils } from '@/hooks/useNavigationUtils';

const CallToAction = () => {
  const navigate = useNavigate();
  const { getWhyFutureLevelPath } = useNavigationUtils();
  
  const handleClick = () => {
    navigate(getWhyFutureLevelPath());
  };

  return (
    <section className="py-20 bg-gradient-to-b from-[#0A0A0A] to-[#090911] relative overflow-hidden">
      {/* Animated gradient background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0">
          {[...Array(5)].map((_, i) => (
            <div 
              key={i}
              className="absolute rounded-full bg-purple-600/10 blur-3xl"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                width: `${Math.random() * 40 + 10}vw`,
                height: `${Math.random() * 40 + 10}vw`,
                opacity: Math.random() * 0.3,
                transform: 'translate(-50%, -50%)',
                animation: `pulse ${Math.random() * 15 + 5}s infinite alternate ease-in-out`,
              }}
            ></div>
          ))}
        </div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold font-future text-white mb-6">
            Bereit, Ihre Marketingstrategie mit KI auf das nächste Level zu bringen?
          </h2>
          <p className="text-xl text-gray-300 mb-12">
            Nutzen Sie unser Kontaktformular – wir melden uns innerhalb von 24 Stunden und beraten Sie unverbindlich.
          </p>
          
          <Button 
            onClick={handleClick}
            className="group neo-button relative overflow-hidden text-lg flex items-center gap-3 px-8 py-7 glow-effect mx-auto"
          >
            Warum Future Level
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            <span className="absolute inset-0 bg-gradient-to-r from-purple-600/0 via-purple-600/30 to-purple-600/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"></span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
